var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 198,
    viewBox: "0 0 196 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18234_94775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4625 75.9L57.6575 82.8825L81.425 82.935L84.1775 76.275",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.365 115.65L128.818 155.813C126.628 161.46 121.198 165.188 115.138 165.188H53.1725C36.2825 165.188 24.6575 148.223 30.755 132.473L46.3025 92.3101C48.4925 86.6626 53.9225 82.9351 59.9825 82.9351H121.948C138.838 82.9351 150.463 99.9001 144.365 115.65Z",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.885 61.2225C27.2484 61.2225 29.975 58.4959 29.975 55.1325C29.975 51.7691 27.2484 49.0425 23.885 49.0425C20.5216 49.0425 17.795 51.7691 17.795 55.1325C17.795 58.4959 20.5216 61.2225 23.885 61.2225Z",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6625 61.2225C50.0259 61.2225 52.7525 58.4959 52.7525 55.1325C52.7525 51.7691 50.0259 49.0425 46.6625 49.0425C43.2991 49.0425 40.5725 51.7691 40.5725 55.1325C40.5725 58.4959 43.2991 61.2225 46.6625 61.2225Z",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.44 61.2225C72.8034 61.2225 75.53 58.4959 75.53 55.1325C75.53 51.7691 72.8034 49.0425 69.44 49.0425C66.0766 49.0425 63.35 51.7691 63.35 55.1325C63.35 58.4959 66.0766 61.2225 69.44 61.2225Z",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.21 61.2225C95.5734 61.2225 98.3 58.4959 98.3 55.1325C98.3 51.7691 95.5734 49.0425 92.21 49.0425C88.8466 49.0425 86.12 51.7691 86.12 55.1325C86.12 58.4959 88.8466 61.2225 92.21 61.2225Z",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.987 61.2225C118.351 61.2225 121.077 58.4959 121.077 55.1325C121.077 51.7691 118.351 49.0425 114.987 49.0425C111.624 49.0425 108.897 51.7691 108.897 55.1325C108.897 58.4959 111.624 61.2225 114.987 61.2225Z",
    stroke: "#FECC53",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.805 71.295H178.22C187.145 71.295 194.39 64.0575 194.39 55.125C194.39 46.2 187.152 38.955 178.22 38.955H162.215",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.84 38.9625H22.5425C13.6175 38.9625 6.3725 46.2 6.3725 55.1325C6.3725 64.0575 13.61 71.3025 22.5425 71.3025H116.533",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3325 32.9775L79.175 26.6325C87.155 6.06752 110.3 -4.13997 130.865 3.84003C151.43 11.82 161.638 34.965 153.658 55.53L140.428 89.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3875 33.69C103.783 21.3675 114.695 20.25 123.215 23.5575C132.905 27.315 137.713 38.22 133.955 47.91L120.365 82.935",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.365 115.65L128.818 155.813C126.628 161.46 121.198 165.188 115.138 165.188H53.1725C36.2825 165.188 24.6575 148.223 30.755 132.473L46.3025 92.3101C48.4925 86.6626 53.9225 82.9351 59.9825 82.9351H121.948C138.838 82.9351 150.463 99.9001 144.365 115.65Z",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.843 115.44L109.483 131.88C107.293 137.528 101.863 141.255 95.8025 141.255H77.9825",
    stroke: "#69B0E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0575 108.907C73.775 107.355 73.01 105.442 73.01 103.357C73.01 98.22 77.6675 94.0425 83.4125 94.0425C89.1575 94.0425 93.3875 96.705 93.3875 101.85C93.3875 106.222 90.7475 109.935 86.2025 110.925L83.4875 124.065H64.97L70.67 115.515",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.727 111.06C174.976 111.06 180.852 105.184 180.852 97.9351C180.852 90.6863 174.976 84.8101 167.727 84.8101C160.479 84.8101 154.602 90.6863 154.602 97.9351C154.602 105.184 160.479 111.06 167.727 111.06Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.727 19.11C171.522 19.11 174.597 16.0342 174.597 12.24C174.597 8.4458 171.522 5.37 167.727 5.37C163.933 5.37 160.857 8.4458 160.857 12.24C160.857 16.0342 163.933 19.11 167.727 19.11Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3725 134.813C18.3082 134.813 23.12 130.001 23.12 124.065C23.12 118.129 18.3082 113.318 12.3725 113.318C6.43682 113.318 1.625 118.129 1.625 124.065C1.625 130.001 6.43682 134.813 12.3725 134.813Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8675 86.5125V100.245",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.73 93.375H23.9975",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3175 174.105V196.245",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3875 185.175H71.2475",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.27 75.5249L139.205 55.3199",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18234_94775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195.015,
    height: 197.37,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.8e2f6a215944c204a7a1698fa7f3c614.svg";
export { ForwardRef as ReactComponent };